import { render, staticRenderFns } from "./AnswerLanguage.vue?vue&type=template&id=1a98b10c&scoped=true&"
import script from "./AnswerLanguage.vue?vue&type=script&lang=js&"
export * from "./AnswerLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a98b10c",
  null
  
)

export default component.exports